import { FormControlLabel, styled, Switch, SwitchProps } from '@material-ui/core';
import {
  Input,
  ISelectValue,
  Select,
  SelectArrowDownIcon,
  TextInput,
  Typography,
} from '@room-match/shared-ui-components';
import { useState } from 'react';
import { COLORS } from 'shared/constants/COLORS';

import {
  CustomFormControl,
  CustomTextInput,
  DiscountContainer,
  FlexContainer,
  FlexTwoColumn,
  MainContainer,
} from './Summary.styles';

const paymentMethodList: ISelectValue[] = [
  {
    key: 'Visa - Ending 1234',
    value: 'Visa - Ending 1234',
  },
];

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  margin: '0 20px 0 10px',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: COLORS.PRIMARY,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#fff',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#1c2531',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const Summary = () => {
  const [method, setMethod] = useState<string>('month');

  const onToggle = (isChecked: any) => {
    if (isChecked) setMethod('year');
    else setMethod('month');
  };

  return (
    <MainContainer>
      <div>
        <FlexContainer>
          <Typography>Monthly</Typography>
          <CustomFormControl
            control={<IOSSwitch />}
            label=""
            value={method === 'month'}
            onChange={(e: any) => onToggle(e.target.checked)}
          />
          <Typography>Yearly (Save 20%)</Typography>
        </FlexContainer>
      </div>
      <div>
        <Select
          fullWidth
          variant="outlined"
          data={paymentMethodList}
          IconComponent={SelectArrowDownIcon}
          name="payment_method"
          placeHolder="Select Payment Method"
          value={'Visa - Ending 1234'}
        />
      </div>
      <div>
        <Typography fontSize={20}>Summary</Typography>
      </div>
      <div>
        <FlexTwoColumn>
          <Typography>Premium Plan ({`${method[0].toUpperCase() + method.substring(1)}ly`})</Typography>
          <Typography>$100 / {method}</Typography>
        </FlexTwoColumn>
        <FlexTwoColumn>
          <Typography>Next Payment</Typography>
          <Typography>09 November 2023</Typography>
        </FlexTwoColumn>
      </div>
      <DiscountContainer>
        <Typography>Discount Code</Typography>
        <CustomTextInput variant="outlined" placeholder="Type here..." />
      </DiscountContainer>
      <FlexTwoColumn>
        <Typography>Tax</Typography>
        <Typography>$5</Typography>
      </FlexTwoColumn>
      <FlexTwoColumn>
        <Typography>Transaction Fees</Typography>
        <Typography>$1.50</Typography>
      </FlexTwoColumn>
      <FlexTwoColumn>
        <Typography fontSize={20}>Grand Total</Typography>
        <Typography fontSize={20}>$106.50</Typography>
      </FlexTwoColumn>
    </MainContainer>
  );
};

export default Summary;
